import { GlobalPermissionType } from '@wavingroup/iot-core/gen/ts/wavin/kleos/v1/global_permission_pb';

export class GlobalPermissionModel {
  readonly permission: GlobalPermissionType;

  readonly title: string;

  constructor(permission: GlobalPermissionType) {
    this.permission = permission;
    this.title = GlobalPermissionType[permission];
  }
}
